/**
 * @flow
 * @format
 */

import _ from 'lodash';

import { isNumeric } from './';
import type { ValidatorType } from './createValidator';

export const minLength: ValidatorType = {
  test: (val: string, threshold: number | string): boolean =>
    val.length > parseInt(threshold, 10),
  message: (val: string, threshold: number | string): string =>
    `Value must be greater than ${threshold}.`,
};

export const isNumber: ValidatorType = {
  test: (val: number | string): boolean => isNumeric(val),
  message: (): string => 'Must be a number.',
};

export const isInteger: ValidatorType = {
  test: (val: number | string): boolean => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+val)) return false;
    // eslint-disable-next-line no-bitwise
    return (parseFloat(+val) | 0) === +val;
  },
  message: (): string => 'Must be an integer.',
};

export const inRange: ValidatorType = {
  test: (val: number | string, range: { max: number, min: number }): boolean =>
    _.inRange(Number(val), range.min, range.max) || Number(val) === range.max,
  message: (): string => 'Value out of range.',
};

export default {
  minLength,
  isNumber,
  inRange,
};



// WEBPACK FOOTER //
// ./src/utils/validators.js